import React, {useState} from 'react';
import { CardBody,  Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";

export default function AmenityTypeFilters(props) {

    const [status, setStatus] = useState(null);
    const [categoryId, setCategoryId] = useState(null);

    const {register, handleSubmit, reset} = useForm();

    const onSubmit = (data, _) => {
        const dataFilter = {
            code  : data.code
        };

        if (status !== null)
            dataFilter.status = status;

        if (categoryId !== undefined && categoryId !== null && categoryId !== '')
            dataFilter.category = { id : categoryId };

        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setCategoryId(null);
        setStatus(null);
        reset();
    }

    const onStatusChange = () => {
        if (status === null)
            setStatus(true);
        else
            setStatus(!status);
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    {/* <Col md="3">
                        <FormGroup>
                            <Label>Categoria</Label>
                            <SelectGeneric
                                initialValue={ categoryId }
                                setExternalValue={ value => setCategoryId( value ) }
                                isDisabled={ false }
                                provider = { hotelCategoryProvider }
                                getAllCategories={true}
                            />
                        </FormGroup>
                    </Col> */}
                    <Col md="3">
                        <FormGroup>
                            <Label>Codigo</Label>
                            <Input 
                                type="text" 
                                name="code"
                                placeholder="Búsqueda por código"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Activo</Label>
                            <br/>
                            <Switch 
                                animate={true} 
                                offText={"No"} 
                                onText={"Si"}
                                value={status}
                                innerRef={register}
                                onChange={onStatusChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div>
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}